<template>
  <div>
    <div
      v-if="!carts || carts.length === 0"
      class="empty-message"
    >Bạn không có sản phẩm nào trong giỏ hàng!
    </div>
    <div
      v-if="carts && carts.length > 0"
      class="list-items">
      <div
        v-if="carts"
        class="row">
        <div
          v-for="cart in carts"
          class="col-sm-6 col-md-4 col-lg-4">
          <div class="row">
            <card-item
              :vatpham="cart"
              @deleteCart="deleteCart($event)"
              @updateCount="updateCount($event)"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="content">
          <div class="content-heading">Nhập mã giảm giá</div>
          <div class="content-body">
            <div class="form-group">
              <div class="promotion">
                <div class="input_code">
                  <input
                    v-model="promo_code"
                    type="text"
                    class="form-control"
                    placeholder="Mã giảm giá/Phiếu quà tặng"
                    @focusin="focusPromo()"
                    @keyup="fillCode($event)"
                  >
                  <button
                    class="btn btn-muangay"
                    @click="verifyPromo()"
                  >Áp dụng
                  </button>
                </div>
                <div class="clearfix"/>
                <div class="text-promotion">
                  Bạn có phiếu quà tặng ?
                  <a href="#">nhập tại đây</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="content">
          <div class="content-body">
            <div class="col-12">
              <div class="row">
                <div class="col-4 text-left">Tạm tính</div>
                <div class="col-8 text-right">{{ amount }} đ</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="content">
          <div class="content-body">
            <div class="col-12">
              <div class="row">
                <div class="col-4 text-left">Thành tiền</div>
                <div class="col-8 text-right total_amount">{{ amount }} đ</div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-3 text-left"/>
                <div class="col-9 text-right text_vat">Đã bao gồm VAT</div>
              </div>
            </div>
            <center>
              <button
                type="button"
                class="btn btn-order btn-pri"
                @click="payment()">Mua ngay
              </button>
              <a href="#">Gửi quà tặng</a>
            </center>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CardItem from './CardItem'
  import formatMoney from '../../utils/StringUtils'
  import rf from '../../communicate/RequestFactory'
  import {errorToaster, infoToaster} from '../../services/ErrorHandler'

  export default {
    name: 'Cart',
    components: {
      CardItem
    },
    data () {
      return {
        carts: [],
        real_amount: 0,
        amount: 0,
        has_code: true,
        promo_code: ''
      }
    },

    computed: {
      isDisabled: function () {
        if (this.promo_code && this.promo_code.length > 0) {
          return true
        }
        return false
      }
    },

    mounted () {
      this.loadCarts()
      this.$store.watch(
        (state, getters) => getters.getCartUpdate,
        (newValue, oldValue) => {
          this.loadCarts()
        }
      )
    },

    methods: {
      loadCarts () {
        const cartsListStorage = localStorage.getItem('carts')
        this.carts = cartsListStorage ? JSON.parse(cartsListStorage) : []
        this.calculateMoney()
      },
      calculateMoney () {
        this.amount = 0
        if (this.carts && this.carts.length > 0) {
          const totalAmount = this.carts.reduce((amount, item) => {
            return (
              amount +
              parseInt(
                item.price_sale &&
                (item.price_sale + '').replace(new RegExp(',', 'g'), '')
              ) *
              item.count
            )
          }, 0)
          this.real_amount = totalAmount;
          this.amount = formatMoney(totalAmount, 0)
        }
      },
      updateCount (vatpham) {
        for (const cart of this.carts) {
          if (cart.id === vatpham.id) {
            cart.count = vatpham.count
          }
        }
        localStorage.setItem('carts', JSON.stringify(this.carts))
        this.$store.dispatch('updateCart')
        this.calculateMoney()
      },
      deleteCart (vatpham) {
        this.carts = this.carts.filter(obj => obj.id !== vatpham.id)
        localStorage.setItem('carts', JSON.stringify(this.carts))
        this.$store.dispatch('updateCart')
        this.calculateMoney()
      },

      focusPromo() {
        window.scrollTo(0, 50);
      },

      verifyPromo () {
        if (!this.promo_code || this.promo_code.length === 0) {
          infoToaster("Cố vấn phong thủy", 'Thông tin mã khuyến mãi không chính xác');
          return;
        }
        localStorage.setItem('promo_code', '');
        this.$Progress.start();
        rf.getRequest("OrderRequest")
          .verifyPromo(this.promo_code)
          .then(res => {
            this.$Progress.finish()
            if (res.status === 200) {
              if (this.validatePromotion(res.data)) {
                  if (this.real_amount >= res.data.condition_use) {
                    this.real_amount = this.real_amount - res.data.discount;
                    this.amount = formatMoney(this.real_amount,0 )
                    localStorage.setItem('promo_code', this.promo_code);
                    localStorage.setItem('discount', res.data.discount);
                    localStorage.setItem('real_amount', this.real_amount);
                  }
              }
            } else if (res.status === 403) {
              this.$router.push('login');
            } else {

              infoToaster("Cố vấn phong thủy", res.message);
              localStorage.setItem('discount', 0);
              localStorage.setItem('real_amount', 0);
            }
          })
          .catch(err => {
            this.$Progress.fail();
            errorToaster("Cố vấn phong thủy", "Xảy ra lỗi kết nối");
          });
      },

      fillCode (event) {
        let keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode === '13' || keycode === 13){
          this.verifyPromo();
        }
      },

      payment () {
        this.$router.push("payment");
      },

      validatePromotion(data) {
        let start_date = new Date(data.begin_date);
        let end_date = new Date(data.end_date);
        let current_time = new Date().getTime();
        if (current_time > start_date.getTime() && current_time < end_date.getTime()) {
          return true;
        }
        return false;
      }
    }
  }
</script>

<style scoped>
  .empty-message {
    font-size: 24px;
    text-align: center;
    margin: 16px;
  }

  .list-items a {
    text-decoration: none;
    color: #000;
  }

  .item {
    margin-bottom: 10px;
  }

  .item-right ul .price span {
    font-size: 12px;
  }

  .item-right ul {
    margin-bottom: 5px;
  }

  .qty_item_click {
    margin-left: 10px;
    border: 1px solid #e2e2e2;
    display: -webkit-flex; /* Safari */
    display: flex;
    width: 60%;
  }

  .qty_item_click div {
    -webkit-flex: 1; /* Safari 6.1+ */
    -ms-flex: 1; /* IE 10 */
    flex: 1;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
  }

  .sub,
  .add {
    background-color: #e2e2e2;
  }

  .content {
    padding: 0;
    border-top: 1px solid #fff;
  }

  .content-heading {
    background-color: #f5f5f5 !important;
    color: #000 !important;
    font-size: 14px;
    font-weight: 500;
    padding: 12px;
  }

  .content-body {
    padding: 10px;
  }

  .content-body a {
    color: #3780e1 !important;
    margin-top: 3px;
  }

  .promotion {
    width: 100%;
  }

  .input_code {
    width: 100%;
  }

  .input_code input[type="text"] {
    width: 68%;
    float: left;
    margin-right: 3px;
  }

  .btn_apdung {
    padding: 6px 15px;
    background: #3780e1;
    color: #fff;
  }

  .text-promotion a {
    color: #3780e1 !important;
    margin-top: 8px;
  }

  .text-promotion {
    margin-top: 8px;
  }

  .total_amount {
    color: #ff595a;
    font-size: 18px;
  }

  .text_vat {
    color: #3780e1;
    font-size: 11px;
  }
  .btn-pri {
    background: #4189EB;
    color: #fff;
    border-radius: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cart/Cart.vue